import React from 'react'
import PropTypes from 'prop-types'
import { Body1 } from '@sainsburys-tech/fable'
import FulfilmentInfoBox from '../FulfilmentInfoBox/FulfilmentInfoBox'

const FulfilmentPassEligibility = ({ productPrice, passThreshold, hasActivePass, isEligibleProduct }) => {
  if (!hasActivePass || !isEligibleProduct) {
    return null
  }

  const renderMessage = () => {
    if (productPrice < passThreshold) {
      return (
        <>
          Spend <strong>£{passThreshold}</strong> on eligible products for free delivery via Argos Plus
        </>
      )
    }

    return 'Eligible for free delivery via Argos Plus'
  }

  return (
    <FulfilmentInfoBox className='ds-items-center'>
      <Body1>{renderMessage()}</Body1>
    </FulfilmentInfoBox>
  )
}

FulfilmentPassEligibility.propTypes = {
  productPrice: PropTypes.number.isRequired,
  passThreshold: PropTypes.number,
  hasActivePass: PropTypes.bool.isRequired,
  isEligibleProduct: PropTypes.bool
}

export default FulfilmentPassEligibility
